import React from 'react';
import styled from 'styled-components';
import { useHistory } from "react-router-dom";


// 모달 버튼


export default function Modal_buttonBack({setShowModal , submitClick}){
    const history = useHistory();
    const goBack = () =>{
        history.goBack();
    }
    return (
        <Modal_button_inner>
            <Modal_btn 
                onClick={()=>{setShowModal(false)}} 
                style={{borderRight:"calc(100vw*(1/375)) solid #c6c6c6"}}>
            {"취소"}
            </Modal_btn>
            <Modal_btn 
                onClick={goBack} 
               >
            {"확인"}
            </Modal_btn>
        </Modal_button_inner>
    )
}




const Modal_button_inner = styled.div`
    width: 100%;
    height: calc(100vw*(44/375));
    border-top: calc(100vw*(1/375)) solid #c6c6c6;
`
const Modal_btn = styled.button`
    width:50%;
    height:100%;
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    line-height: 1.38;
    text-align: center;
    color: #008aff;
`